import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const CityThumbnail = memo(({ cityName, cityLabel }) => {
    return (
        <>
            <ThumbnailContainer>
                <Thumbnail cityName={cityName} />
                <Label>
                    {cityLabel}
                </Label>
            </ThumbnailContainer>
        </>
    );
});

CityThumbnail.displayName = 'CityThumbnail';
CityThumbnail.propTypes = {
    cityName: PropTypes.string,
    cityLabel: PropTypes.string,
};

const ThumbnailContainer = styled.div`
position: relative;
height: 160px;
`;

const Thumbnail = styled.div`
background-image: ${({ cityName }) =>
        cityName ? 'url(img/travel/' + cityName.toLowerCase().replace(' ', '-') + '@2x.png)' : ''};
width: 100%;
height: 100%;
background-size: cover;
background-repeat: no-repeat;
background-position: center;
border-radius: 2px 2px 0 0;
`;

const Label = styled.div`
position: absolute;
left: 12px;
bottom: 6px;
font-size: 18px;
font-weight: 600;
color: white;
`;
